
"use strict"; // jshint ignore:line

import { exportArrangement, applyArrangement } from "../Arrangements.js";

export default function ArrangementService( $rootScope,  $http,  $q,  $location,  ipCookie,  gettextCatalog,  Notification,  $User,  $userAssets,  $ApiHandler,  $oeuvresHandler,  PreviewModelService,  spherical360SetupService ) {

	var self = this;

	function imageDataFromApiToSrc( url ){
		return $ApiHandler.get(url, {
			filters: "asarray,onlydata,onlyattrs"
		}).then(function(response){
			return $q(function(resolve, reject){
				var img = new Image();
				img.onload = function(){
					var canvas = document.createElement('canvas');
					canvas.width = img.width;
					canvas.height = img.height;
					canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
					canvas.toBlob(function( blob ){
						resolve(URL.createObjectURL( blob ));
					});
				}
				img.onerror = reject;
				img.src     = (response.data||response)[0].data;
			});
		});
	}

	this.generateArrangementsModelsData = function generateArrangementsModelsData(){
		var arrangements, models;

		return $q.all([
			_fetchArrangements( ).then(function(v){ arrangements = v.data; }),
			PreviewModelService.fetchPreviewModels().then(function( _models ){ models = _models; })
		]).then(function(){
			var models_uids = [];

			for (let i in models) {
				for( var uid in models[ i ].with.arrangements ){
					arrangements[ uid ] = arrangements[uid] || models[ i ].with.arrangements[ uid ];
				}
			}

			for (let uid in arrangements) {
				if( !models[ arrangements[ uid ].preview_model_uid ]){
					if( models_uids.indexOf( arrangements[ uid ].preview_model_uid ) == -1 ){
						models_uids.push( arrangements[ uid ].preview_model_uid );
					}
				}
			}

			return $q.all( models_uids.map(function( uid ){
				return PreviewModelService.fetchPreviewModel( uid, true ).then(function( result ){
					if( result ) models[ result.uid ] = result;
				}).catch(function( err ){
					console.error( err );
				});
			}));
		}).then(function(){
			_refreshDatas( models, arrangements );

			return {
				models       : models,
				arrangements : arrangements
			};
		});

		function _refreshDatas( models, arrangements ){
			for (let uid in models) {
				if (!models[ uid ].$access) models[ uid ].$access = 1;

				models[ uid ].updated_at && ( models[ uid ].updated_at = new Date(models[ uid ].updated_at ));
				models[ uid ].created_at && ( models[ uid ].created_at = new Date(models[ uid ].created_at ));

				models[ uid ].$arrangements = {};
			}

			for (let uid in arrangements) {
				if( models[ arrangements[ uid ].preview_model_uid ]){
					arrangements[ uid ].updated_at && ( arrangements[ uid ].updated_at = new Date(arrangements[ uid ].updated_at ));
					arrangements[ uid ].created_at && ( arrangements[ uid ].created_at = new Date(arrangements[ uid ].created_at ));

					arrangements[ uid ].$model = models[ arrangements[ uid ].preview_model_uid ];
					arrangements[ uid ].$model.$arrangements[ uid ] = arrangements[ uid ];
				} else {
					delete arrangements[ uid ];
				}
			}

			for( var uid in models ){
				models[ uid ].$arrangements_count = Object.keys( models[ uid ].$arrangements ).length;
				models[ uid ].$config = self.generateArrangementsModelsData.buildModelConfig( models[ uid ]);
			}
		}

		function _fetchArrangements( ){
			return $ApiHandler.get("/model_preview/arrangements", {
				with: "models",
				filters: "onlydata,onlyattrs"
			}).catch(function( err ){
				console.error( err );
				return { data: { } };
			});
		}
	}
	this.generateArrangementsModelsData.buildModelConfig = function( model, config ){
		config = config || {};

		if( !config.model_source ){
			config.model_source = "url";
			if( model.config.default_source == "url" && model.config.default_url ){
				config.url = model.config.default_url;
			} else if( model.config.default_source == "attachment" && model.config.attachment_uid ){
				config.url = "/ajax/attachments/"+ model.config.attachment_uid +".json?download";
			}
		}

		if( model.config.scale && !isNaN( model.config.scale = parseFloat( model.config.scale ))){
			config.scale = model.config.scale;
		}

		if( model.config.player ){
			config.player = model.config.player;
		}

		return config;
	};

	this.getArrangement = function( arrangement_uid ){

		var defer, resource = "/model_preview/arrangements/" + arrangement_uid + "?filters=asarray,onlydata,onlyattrs&with=model";

		try {
			defer = $ApiHandler.findOrGet( resource );
		} catch (error) {
			console.error( error );
		}
		
		return $q.when( defer || $ApiHandler.get( resource )).then(function( arrangement ) {
			arrangement = arrangement.data[0];
			arrangement.$model = arrangement.with.model;
			arrangement.updated_at = new Date(arrangement.updated_at);
			arrangement.created_at = new Date(arrangement.created_at);
			return arrangement;
		});
	};

	this.fillArrangement = function( arrangement ){
		
		if (arrangement.$filled) return $q.when( arrangement );

		$rootScope.loading = true;

		// @TODO Selvitä onko arrangement.oeuvres taulukko vai objekti. arrangement.oeuvres olisi oltava taulukko
		var arrangement_oeuvres = Object.keys( arrangement.oeuvres || [ ]).map(function( i ) {
			return arrangement.oeuvres[ i ];
		});

		var missing_uids = arrangement_oeuvres.map(function(uid){ return uid; });

		var prms, resource = "/clients/oeuvres?clients_oeuvres_uids=" + (arrangement_oeuvres.filter(function(uid){ return uid.substr(0,2)=="92"; }).join(",")) + "&filters=onlyattrs,onlydata"

		try {
			if (resource.length > 200) {
				prms = $userAssets.getClientsOeuvresRaw( missing_uids.filter(function(uid){ return uid.substr(0,2)=="92"; })).then(function( data ) { return { data: data }; });
			} else {
				prms = $ApiHandler.findOrGet( resource );
			}
		} catch (error) { console.error( error ); }

		return $q.when( prms || $ApiHandler.get("/clients/oeuvres", {
			clients_oeuvres_uids: arrangement_oeuvres.filter(function(uid){ return uid.substr(0,2)=="92"; }).join(","),
			filters : "onlyattrs,onlydata"
		}))
		.then(function( response ){
			var oeuvres = response.data;
			for( var i in oeuvres ) missing_uids.splice( missing_uids.indexOf( oeuvres[i].uid ), 1 );

/*			return $ApiHandler.get("/remotes/oeuvres", {
				where   : JSON.stringify({ uid: { $in: missing_uids.filter(function(uid){ return uid.substr(0,2)=="BC"; })}}),
				filters : "asarray,onlyattrs,onlydata"
			}).then(function( moeuvres ){*/


			var _missings = missing_uids.filter(function(uid){ return uid.substr(0,2)=="BC"; });

			if( _missings.length == 0 ) return oeuvres;

			return $ApiHandler.get("/remotes/oeuvres", {
				where   : JSON.stringify({ uid: { $in: _missings } }),
				filters : "asarray,onlyattrs,onlydata"
			}).then(function( response ){
				var moeuvres = response.data;

				for( var i in moeuvres ){
					var o = moeuvres[i];
					missing_uids.splice( missing_uids.indexOf( o.uid ), 1 );
					oeuvres[ o.uid ] = o;
					o.with = {
						oeuvre: {
							title  : o.data.name,
							width  : parseFloat(o.data.width),
							height : parseFloat(o.data.height),
							depth  : o.data.depth && parseFloat(o.data.depth)
						}
					}
				}

				return $q.all(moeuvres.map(function(o){
					var src;
					switch( o.remote_provider_key ){
						case "adlib": src = "/interfaces/adlib/records/"+o.data.id+"/images/"+o.data.image_data.id; break;
						default: debugger;
					}
					return imageDataFromApiToSrc( src ).then(function( src ){
						oeuvres[ o.uid ].$img_url = oeuvres[ o.uid ].$img_url_thumb = src;
					});
				}));
			}).then(function(){
				return oeuvres;
			});
		})
		.then(function( oeuvres ) {
			arrangement.$filled = true;
			arrangement.$oeuvres = oeuvres;

			for( var key in arrangement.data ){
				arrangement[key] = arrangement.data[key];
			}

			for( var uid in oeuvres ){
				oeuvres[ uid ].$img_url_thumb = oeuvres[ uid ].$img_url_thumb || "/i/"+ oeuvres[ uid ].with.oeuvre.img_uid +"?size=200x200^";

				if( arrangement.oeuvres[ uid ]){
					arrangement.oeuvres[ uid ].uid = uid;
				}
			}

			if( $rootScope.selected_file ) arrangement.model.file = $rootScope.selected_file;

			return arrangement;
		});
	};

	this.applyArrangement = function( arrangement ) {
		/**
		 * @TODO: Todennäköisesti enablointi/disablointi hajoaa jotenkin sommitelmaa vaihdettaessa tästä kikkailusta huolimatta
		 */

		var wasSpherical360Setup = spherical360SetupService.enabled;

		return $q.when( applyArrangement( arrangement )).then(function() {

			var isSpherical360Setup = false

			if (arrangement.$config.type == "spherical360") {
				isSpherical360Setup = true;
			}

			if (spherical360SetupService.setups.length > 0) {

				if (!spherical360SetupService.setupPlayerAttachedTo) {

					spherical360SetupService.attachPlayer( spherical360SetupService.setups[0] );
				
					isSpherical360Setup = true;
				}
			}

			if (wasSpherical360Setup && !isSpherical360Setup) {

				spherical360SetupService.disable();

			} else if (isSpherical360Setup) {

				spherical360SetupService.enable();
			}
		});
	}

	this.exportArrangement = (function() {
		return function( arrangement ){
			var _arrangement, model;

			if( arrangement ) {
				var _o = window.selected_lists;
				window.selected_lists = arrangement.lists.map(function(uid){ return { uid: uid }; });
				_arrangement = exportArrangement();
				window.selected_lists = _o;

				model = arrangement && arrangement.data && arrangement.data.model;
			} else {
				_arrangement = exportArrangement();
				arrangement = {};
				arrangement.lists = arrangement.lists_uids;

				model = _arrangement.model;
			}

			arrangement.oeuvres_uids = Object.keys($oeuvresHandler.oeuvres);

			arrangement.data = {
				version    : _arrangement.version,
				oeuvres    : _arrangement.oeuvres,
				player     : _arrangement.player,
				walls      : _arrangement.walls,
				addit_objs : _arrangement.addit_objs,

				scene              : exportScene(),
				catalogs           : exportCatalogs( arrangement ),
				environment        : exportEnvironment(),

				spherical360Setups : spherical360SetupService.genSaves()
			};
			
			// Jotta ei tallenneta automaattisesti luotavaa maailmanvaloa uutena valona, poistetaan se lisäobjektien joukosta
			if (gameService && gameService.worldLight && arrangement.data.addit_objs[ gameService.worldLight.uuid ]) {
				delete arrangement.data.addit_objs[ gameService.worldLight.uuid ];
			}
			

			arrangement.data.model = model;

			return arrangement;
		};

		function exportCatalogs( arrangement ) {

			let catalogs = [];

			if (arrangement && arrangement.catalogs) {
				for (let catalog of arrangement.catalogs) {
					catalogs.push( catalog.toJSON() );
				}
			}

			return catalogs;
		}

		function exportScene() {
			var data = {};

			try {
				if (gameService && gameService.worldLight) data.worldLight = gameService.worldLight.toJSON();
			} catch (error) {}

			return data;
		}

		function exportEnvironment() {
			var data = {
				physics: {}
			};

			let { environment, player } = gameService;

			try {
				if (environment && environment.backgroundAudio) {
					data.backgroundAudio = angular.copy( environment.backgroundAudio );
				}
			} catch (error) {}

			try {
				if (player) {
					let { disableGravity } = player.getOpts();
					data.physics.gravityDisabled = !!disableGravity;
				}

			} catch (error) {}

			return data;
		}
	})();

	/**
	 * Suoritetaan asykronisia valmisteluja, kuten DataUrien kuvien uploadausta
	 */
	this.exportArrangementAsync = function( arrangement ) {

		return $q.when( this.exportArrangement( arrangement )).then(function( arrangement ) {

			var prms = [];


			var spherical360Setups = arrangement.data.spherical360Setups;
			if (spherical360Setups) {
				Object.keys( spherical360Setups ).forEach(function( uuid ) {
					try {
						var setup = spherical360Setups[ uuid ];
						if (angular.isString( setup.texture ) && (/^data:image\/[^;]+;base64,/).test( setup.texture.substr( 0, 25 ) )) {
							prms.push(function() {
								return $userAssets.uploadImage( setup.texture ).then(function( response ) {
									setup.texture = "/i/" + response.uid + "?size=1024x1024^";

									//try {
									//	spherical360SetupService.setups[ uuid ].setTexture('/i/B200000000072152?size=full')
									//} catch (error) { console.error( error ); }
								});
							});
						}
					} catch (error) { console.error( error ); }
				});
			}


			return $q.allIterator( prms, 100 ).then(function() {
				return arrangement;
			});
		});
	}

	this.saveArrangement = function( arrangement ){

		try {

			if (!$User.logged) throw new Error("Failed to save arrangement, you must be logged in");

			// arrangement = this.exportArrangement( arrangement );
			
			return this.exportArrangementAsync( arrangement ).then(function( arrangement ) {

				if (arrangement.uid && arrangement.uid.match( /^A5[a-fA-F0-9]{14}$/ )) {
					return self.updateSavedArrangementData( arrangement );
				} else {
					return self.uploadNewArrangement( arrangement );
				}

			});

		} catch( err ){
			console.error(err);
			var prm = $q.defer();
			prm.reject(err);
			return prm.promise;
		}
	};

	this.updateSavedArrangement = function( arrangement ){
		if( typeof arrangement.uid == "string" && arrangement.uid.match( /^A5[a-fA-F0-9]{14}$/ )){
			return this.updateSavedArrangementData( arrangement )
			.then(function(){
				arrangement.updated_at = new Date();
			});
		} else {
			throw new Error("Unknown arrangement");
		}
	};

	this.saveArrangementData = function( arrangement ){
		var promise;

		if( typeof arrangement.uid == "string" && arrangement.uid.match( /^A5[a-fA-F0-9]{14}$/ )){
			promise = this.updateSavedArrangementData( arrangement )
			.then(function(){
				arrangement.updated_at = new Date();
			});
		} else {
			throw new Error("Unknown arrangement");
		}

		return promise;
	};

	this.removeArrangement = function( arrangement ){
		return this._removeArrangement( arrangement )
		.then(function(){
			var idx, model = arrangement.$model;
			if( model ){

				delete model.with.arrangements[ arrangement.uid ];

				if(( idx = model.$arrangements_arr.indexOf( arrangement )) != -1 ){
					model.$arrangements_arr.splice( idx, 1 );
				}

				model.$arrangements_count = model.$arrangements_arr.length;
			}
			return arrangement;
		});
	};

	this.cloneArrangement = function( arrangement ){

		var data = angular.copy({
			preview_model_uid : arrangement.preview_model_uid,
			oeuvres_uids      : arrangement.oeuvres_uids,
			lists             : arrangement.lists,
			title             : arrangement.title,
			data              : arrangement.data
		});

		if (!data.title) {
			data.title = gettextCatalog.getString( "Unnamed arrangement");
		}

		data.title += " " + gettextCatalog.getString( "(Clone)" );

		return this.uploadNewArrangement( data );
	};

	/*******/

	this.uploadNewArrangement = function( arrangement ){
		var body = {
			"model_preview_arrangement.preview_model_uid" : arrangement.preview_model_uid || window.selected_model.uid,
			"model_preview_arrangement.owner_uid"         : arrangement.owner_uid         || $User.uid,
			"model_preview_arrangement.oeuvres"           : arrangement.oeuvres_uids      || ((typeof arrangement.oeuvres=="object")?Object.keys(arrangement.oeuvres):arrangement.oeuvres),
			"model_preview_arrangement.lists"             : arrangement.lists             || window.selected_lists.map(function(v){ return v.uid || v; }),
			"model_preview_arrangement.title"             : arrangement.title,
			"model_preview_arrangement.data"              : arrangement.data
		};

		return $ApiHandler.post("/model_preview/arrangements/", {}, body, { raw_response: true })
		.then(function(response){
			arrangement.uid = response.headers("location").substr(-16);
			return arrangement;
		});
	};

	this.updateSavedArrangementData = function( arrangement ){
		var oeuvres_uids = arrangement.oeuvres_uids || [];
		for( var oeuvre_uid in arrangement.data.oeuvres ) if( oeuvres_uids.indexOf( oeuvre_uid ) == -1)  oeuvres_uids.push( oeuvre_uid );
		var body = {
			"model_preview_arrangement.uid":  arrangement.uid,
			"model_preview_arrangement.data": arrangement.data,
			"model_preview_arrangement.oeuvres": oeuvres_uids
		};
        if( arrangement.lists != null ) body["model_preview_arrangement.lists"] = arrangement.lists;

		return $ApiHandler.post("/model_preview/arrangements/"+arrangement.uid, {}, body );
	};
	this.updateSavedArrangementData.buildBody = function( arrangement ){
		var oeuvres_uids = arrangement.oeuvres_uids || [];
		for( var oeuvre_uid in arrangement.data.oeuvres ) if( oeuvres_uids.indexOf( oeuvre_uid ) == -1)  oeuvres_uids.push( oeuvre_uid );
		var body = {
			"model_preview_arrangement.uid":  arrangement.uid,
			"model_preview_arrangement.data": arrangement.data,
			"model_preview_arrangement.oeuvres": oeuvres_uids
		};
        if( arrangement.lists != null ) body["model_preview_arrangement.lists"] = arrangement.lists;

		return body;
	};

	this.updateSavedArrangementTitle = function( arrangement ){
		var body = {
			"model_preview_arrangement.uid":   arrangement.uid,
			"model_preview_arrangement.title": arrangement.title
		};

		return $ApiHandler.post("/model_preview/arrangements/"+arrangement.uid, {}, body );
	};
	this._removeArrangement = function( arrangement ){
		var body = {
			"model_preview_arrangement.uid":   arrangement.uid
		};

		return $ApiHandler.delete("/model_preview/arrangements/"+arrangement.uid, {}, body );
	}
}

ArrangementService.$inject = ["$rootScope","$http","$q","$location","ipCookie","gettextCatalog","Notification","$User","$userAssets","$ApiHandler","$oeuvresHandler","PreviewModelService","spherical360SetupService" ];